import PostMessage from "./postMessage.mjs";
function exec(command) {
  return new Promise((resolve, reject) => {
    try {
      PostMessage.sendCommand(command, (response) => {
        resolve(response);
      });
    } catch (e) {
      reject(e);
    }
  });
}
export {
  exec
};
